export const portal_api_url = process.env.REACT_APP_FIREBASE_CONFIG === 'production'
  ? 'https://portal-api-u7wfvp56wa-ew.a.run.app'
  : process.env.REACT_APP_FIREBASE_CONFIG === 'localhost'
    ? 'http://localhost:2021'
    : 'https://portal-api-pj2r6ugwdq-ew.a.run.app';
